// Utils
import { assert, isObject } from 'ezyvet-fe-helpers';
import { decommitObject } from './decommitObject';
/**
 * Strips [COMMITTED_VALUES] from the the given object and nested objects.
 *
 * @template T extends object
 * @param {Committable<T>} values
 *
 * @return {UnCommittable<T>}
 */
export var decommit = function (values) {
    assert(isObject(values), 'You can only decommit an object');
    return decommitObject(values);
};
//# sourceMappingURL=decommit.js.map